export const createServer = () => ({ 
  listen: () => {} 
});

export const createConnection = () => ({
  destroy: () => {},
  end: () => {},
  on() {
    return this;
  },
  pipe() {
    return this;
  },
  write: () => {},
});

export default { createServer, createConnection };
